import { Navigate, useNavigate, useOutletContext } from "react-router-dom";

import { IntegrationShell } from "../../common/Shell";
import MCubeForm from "./MCubeForm";
import { useLayoutEffect } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function MCubeIntegration() {
  const {
    projectId,
    thirdpartyData,
    updateThirdpartyData,
    company,
    isThirdPartyLoading,
    isViewOnly
  } = useOutletContext();

  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (
      company &&
      !company?.thirdPartyIntegrationVisibility.showMCubeIntegration
    ) {
      navigate("/not-found", { replace: true });
    }
  }, [company]);

  if (!company) {
    return null;
  }

  if (
    company &&
    company?.thirdPartyIntegrationVisibility &&
    !company.thirdPartyIntegrationVisibility?.showMCubeIntegration
  ) {
    return (
      <Navigate
        to="not-found"
        replace
      />
    );
  }

  if (isThirdPartyLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    );
  }

  return (
    <IntegrationShell>
      <MCubeForm
        workspaceId={projectId}
        mcubeSettings={thirdpartyData?.telephonySettings.mcubeSettings}
        updateMcubeSettings={updateThirdpartyData}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
